import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlidesWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSlidesWide"><Path d="M6.5 15.5H2.5V4.5H17.5V8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 19.5V8.5H21.5V19.5H6.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSlidesWide;
